import React from "react";
import PropTypes from "prop-types";
import { Text, Box, IconSvg } from "samba-ui";
import {
  Container,
  ClientName,
  FeedNameAndType,
  CloseButtonContainer
} from "./styles";

import { FEED_TYPE_MAPPING } from "../../../../constants";

const Header = ({ step, onDismiss, feed, selectedClient }) => {
  const title = step === "setCountry" ? "Select a country" : "Create a feed";

  if (step === "setCountry" || step === "clientAndType") {
    return (
      <Container>
        <Text>{title}</Text>
        <CloseButtonContainer onClick={onDismiss}>
          <IconSvg name="close" />
        </CloseButtonContainer>
      </Container>
    );
  } else {
    return (
      <Container>
        <Box>
          <ClientName>{selectedClient.name}</ClientName>
          <FeedNameAndType>{`${feed.name} • ${
            FEED_TYPE_MAPPING[feed.type]
          } File`}</FeedNameAndType>
        </Box>
        <CloseButtonContainer onClick={onDismiss}>
          <IconSvg name="close" />
        </CloseButtonContainer>
      </Container>
    );
  }
};

Header.propTypes = {
  step: PropTypes.string,
  onDismiss: PropTypes.func,
  selectedClient: PropTypes.shape({
    name: PropTypes.string
  }),
  feed: PropTypes.shape({
    name: PropTypes.string
  })
};

export default Header;
